(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cm-product-gift-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cm-gift-options')) {
    class CmGiftOptions extends HTMLElement {
      connectedCallback() {
        this.giftTitle = this.dataset.giftVariantTitle || '';
        this.fields = Array.from(this.querySelectorAll('input, textarea'));
        this.messageField = this.querySelector('[data-gift-message]');
        this.counter = this.querySelector('[data-gift-count]');

        this.onScopeChange = this.onScopeChange.bind(this);
        this.onMessageInput = this.onMessageInput.bind(this);

        this.scope = this.closest('.shopify-section') || document;
        this.scope.addEventListener('change', this.onScopeChange);

        if (this.messageField) {
          this.messageField.addEventListener('input', this.onMessageInput);
          this.onMessageInput();
        }
      }

      disconnectedCallback() {
        if (this.scope) this.scope.removeEventListener('change', this.onScopeChange);
        if (this.messageField) this.messageField.removeEventListener('input', this.onMessageInput);
      }

      onScopeChange(event) {
        const target = event.target;
        if (!target || target.dataset.optionValueId === undefined) return;
        this.setGiftVisible(target.value === this.giftTitle);
      }

      setGiftVisible(show) {
        this.hidden = !show;
        this.fields.forEach((field) => {
          field.disabled = !show;
        });
      }

      onMessageInput() {
        if (!this.counter || !this.messageField) return;
        const max = this.messageField.maxLength;
        const len = this.messageField.value.length;
        this.counter.textContent = len + ' / ' + max;
      }
    }

    customElements.define('cm-gift-options', CmGiftOptions);
  }
  } catch(e) { console.error(e); }
})();

})();
